import { RESET_APP } from '../actions/index';
import { languageJson } from '../utilities/constants';
import {
  UPDATE_LANGUAGE
} from '../actions/language';

// Defaulting english as the language...

const initialState = languageJson[1];

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_APP:
      return initialState;
    case UPDATE_LANGUAGE:
      return languageJson[action.language_id];
    default:
      return state;
  }
};
